export default {
  title: 'Настройки ProPush',

  widgets: {
    title: 'Виджеты',

    titles: {
      create: 'Создать виджет',
      settings: 'Настройки',
      channels: 'Каналы'
    },

    labels: {
      name: 'Название',
      isActive: 'Активен',
      isBlocked: 'Заблокирован',
      owner: 'Владелец',
      channels: 'Каналы'
    },

    hints: {
      notFound: 'Виджеты не найдены',
      channels: 'Чтобы каналы успешно привязались к виджету, необходимо выбрать нужные каналы и нажать кнопку "Привязать".'
    },

    tooltips: {
      isActive: {
        true: 'Виджет активен',
        false: 'Виджет не активен'
      },

      isBlocked: {
        true: 'Виджет заблокирован администратором'
      }
    },

    infos: {
      channels: 'Для успешной работы виджета необходимо привязать к нему каналы.<br>Для этого выберите нужные каналы и нажмите кнопку "Сохранить".',
      ipWhitelist: 'В поле IP-адреса можно указать адреса или CIDR-диапазоны, с которых будут разрешены запросы в систему. Используйте диапазон <b>0.0.0.0/0</b>, если ограничение не требуется.',

      user: {
        channels: 'Для успешной работы пользовательского виджета необходимо разрешить ему использовать определенные каналы.<br>Для этого выберите нужные каналы и нажмите кнопку "Сохранить".'
      }
    },

    warnings: {
      channels: 'Нет доступных активных каналов. Пожалуйста, обратитесь в службу поддержки.'
    },

    snackbars: {
      created: 'Виджет успешно создан',
      updated: 'Виджет успешно обновлен',
      removed: 'Виджет успешно удален',

      channels: {
        attached: 'Каналы успешно привязаны'
      }
    }
  },

  channels: {
    title: 'Каналы',

    titles: {
      create: 'Создать канал',
      templates: 'Шаблоны',

      additionalSettings: {
        title: 'Дополнительные настройки',
        code: 'Настройки кода'
      }
    },

    labels: {
      name: 'Название',
      channelType: 'Тип канала',
      templates: 'Шаблоны',

      additionalSettings: {
        code: {
          length: 'Длина кода',
          beautify: 'Красивый код'
        },
        lifetime: 'Время жизни кода, сек',
        numberOfTries: 'Количество попыток ввода кода',
        numberOfRestart: 'Количество перезапуска канала',
        mtsClientId: 'MTS Client ID'
      }
    },

    hints: {
      notFound: 'Каналы не найдены',
      templates: 'Чтобы шаблоны успешно привязались к каналу, необходимо выбрать нужные шаблоны и нажать кнопку "Привязать".',
      additionalSettings: 'Время жизни и количество попыток должно быть больше 0'
    },

    infos: {
      templates: 'Для успешной работы канала необходимо привязать к нему шаблоны.<br>Для этого выберите нужные шаблоны и нажмите кнопку "Сохранить".'
    },

    warnings: {
      templates: 'Нет доступных шаблонов.'
    },

    snackbars: {
      created: 'Канал успешно создан',
      updated: 'Канал успешно обновлен',
      removed: 'Канал успешно удален',

      templates: {
        attached: 'Шаблоны успешно привязаны'
      }
    }
  },

  templates: {
    title: 'Шаблоны',

    titles: {
      create: 'Создать шаблон',
      conditions: 'Условия'
    },

    labels: {
      name: 'Название',
      channelType: 'Тип канала',

      additionalSettings: {
        senderId: 'Отправитель',
        template: 'Шаблон'
      }
    },

    hints: {
      notFound: 'Шаблоны не найдены',

      additionalSettings: {
        template: 'Для подстановки кода используйте {{ code }}'
      }
    },

    snackbars: {
      created: 'Шаблон успешно создан',
      updated: 'Шаблон успешно обновлен',
      removed: 'Шаблон успешно удален'
    }
  }
}
